import {isNil} from 'ramda';

import type {RoutePoint} from './getRouteBounds';

const EARTH_RADIUS_METERS = 6_371_000;
const DEGREES_TO_RADIANS = Math.PI / 180;

// The equirectangular approximation, precise enough for the short steps of a recorded drive.
const getDistanceMeters = (from: RoutePoint, to: RoutePoint) => {
  const x =
    (to.lng - from.lng) *
    DEGREES_TO_RADIANS *
    Math.cos(((from.lat + to.lat) / 2) * DEGREES_TO_RADIANS);
  const y = (to.lat - from.lat) * DEGREES_TO_RADIANS;
  return Math.hypot(x, y) * EARTH_RADIUS_METERS;
};

/** Distance in metres from the start to every point of the route, the first one is 0. */
export const getRouteDistances = (path: RoutePoint[]) =>
  path.reduce<number[]>((distances, point, index) => {
    const previous = path[index - 1];
    const travelled = distances[index - 1] ?? 0;
    // Pushing keeps this linear, the route can have thousands of points after smoothing.
    distances.push(isNil(previous) ? 0 : travelled + getDistanceMeters(previous, point));
    return distances;
  }, []);
